var map = {
	"./dashboard/premium-courses.png": 2297,
	"./details_close.png": 3441,
	"./details_open.png": 2005,
	"./email-template/10.jpg": 9955,
	"./email-template/11.jpg": 6790,
	"./email-template/3.png": 2545,
	"./email-template/4.png": 4830,
	"./email-template/invoice-1/1.png": 1457,
	"./email-template/invoice-1/sign.png": 5249,
	"./email-template/invoice-3/bg-0.png": 4498,
	"./email-template/invoice-3/sign.png": 1007,
	"./email-template/pdfs.png": 7921,
	"./forms/user.png": 2157,
	"./login/1.jpg": 6369,
	"./login/2.jpg": 4166,
	"./login/3.jpg": 4275,
	"./login/icon.png": 1997,
	"./login/login_bg.jpg": 7665,
	"./logo/iroot.png": 8077,
	"./logo/landing-logo.png": 1925,
	"./logo/login-bg-new.jpg": 2538,
	"./logo/login-bg-resized.jpg": 8980,
	"./logo/login-bg.jpg": 9707,
	"./logo/logo-dark-resized.png": 5585,
	"./logo/logo-dark.png": 9186,
	"./logo/logo-icon.png": 5485,
	"./logo/logo-sm-resized.png": 309,
	"./logo/logo-sm.png": 3430,
	"./logo/logo.png": 6447,
	"./logo/logo1.png": 9622,
	"./logo/logo3.png": 1300,
	"./logo/logo4.png": 2955,
	"./logo/logo7.png": 4624,
	"./logo/logo_dark.png": 1832,
	"./other-images/bg-profile.png": 3887,
	"./other-images/boxbg.jpg": 138,
	"./other-images/coming-soon-bg.jpg": 1823,
	"./other-images/maintenance-bg.jpg": 8465,
	"./slider/1.jpg": 1719,
	"./slider/10.jpg": 5639,
	"./slider/11.jpg": 9802,
	"./slider/2.jpg": 2792,
	"./slider/3.jpg": 53,
	"./slider/4.jpg": 9166,
	"./slider/5.jpg": 5627,
	"./slider/6.jpg": 7932,
	"./slider/7.jpg": 5305,
	"./slider/8.jpg": 5682,
	"./slider/9.jpg": 5679,
	"./social-app/social-image.png": 8709,
	"./switch/square-gray.png": 6710,
	"./switch/square.svg": 6044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4002;